export default __webpack_public_path__ + "static/media/StartScreen.7c185e0b.svg";